module.exports = __webpack_public_path__ + "static/alexSiteTitle-41b28d7fa0113fb5138d3a90741e7d9c.gif";